import * as React from "react";
import ConfigContext from "../context/ConfigContext";
import * as Icons from "../components/Icons";
import { EngagementConfiguration } from "../types";

interface ConfigExtension {
  config: EngagementConfiguration;
}

interface EyecatcherProps {
  isChatAvailable: boolean;
  onClick: () => void;
  onDismiss: () => void;
}

interface EyecatcherState {
  hovering: boolean;
}

class Eyecatcher extends React.Component<
  EyecatcherProps & ConfigExtension,
  EyecatcherState
> {
  state = {
    hovering: false
  };

  onMouseEnter = () => {
    this.setState({
      hovering: true
    });
  };

  onMouseLeave = () => {
    this.setState({
      hovering: false
    });
  };

  getSrc() {
    return this.props.isChatAvailable
      ? this.props.config.EyecatcherOnlineUrl
      : this.props.config.EyecatcherOfflineUrl;
  }

  renderDismissIcon() {
    if (!this.state.hovering) {
      return null;
    }

    return (
      <span className="eyecactcher-dismiss" onClick={this.props.onDismiss}>
        <Icons.CloseIcon color="#ffffff" />
      </span>
    );
  }

  getEyecatcherClass() {
    if (this.props.isChatAvailable) {
      return "velaro-available-eyecatcher";
    } else {
      return "velaro-unavailable-eyecatcher";
    }
  }

  render() {
    const src = this.getSrc();
    if (!src) {
      return null;
    }

    if (screen.width <= 800 || screen.height <= 600) {
      console.log("Hiding eyecatcher - device too small");
      return null;
    }

    return (
      <div
        className="velaro-eyecatcher-container"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        aria-hidden="true"
      >
        <div className={this.getEyecatcherClass()}>
          <img
            alt="Eye catcher"
            onClick={this.props.onClick}
            src={src}
            style={{ cursor: "pointer" }}
            aria-hidden="true"
          />
          {this.renderDismissIcon()}
        </div>
      </div>
    );
  }
}

export default (props: EyecatcherProps) => (
  <ConfigContext.Consumer>
    {config => <Eyecatcher config={config} {...props} />}
  </ConfigContext.Consumer>
);
